// @ts-ignore
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";
import newSplashImage1 from "../../assets/images/new-splash1.png";
import newSplashImage2 from "../../assets/images/new-splash2.png";
import newSplashImage3 from "../../assets/images/new-splash3.png";
import { useBrand } from "../../hooks/useBrand";

const carouselData = [
  {
    thumbnail: newSplashImage2,
    title: "Welcome to {appName}!",
    content: "The lifestyle app built to make your life easier, affordable and more enjoyable.",
  },
  {
    thumbnail: newSplashImage1,
    title: "Curated for You.",
    content: "Discover exclusive offers from the brands you already know and love.",
  },
  {
    thumbnail: newSplashImage3,
    title: "Enjoy The Perks.",
    content: "From your favourite meals to essential services, save more on what you enjoy.",
  },
];

export default function Carousel() {
  const { appName } = useBrand();
  const swiperOptions = {
    modules: [Pagination, Autoplay],
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      clickable: true,
    },
  };

  return (
    <div className="w-full h-full">
      <div className="absolute inset-0 bg-gradient-overlay pointer-events-none z-10"></div>
      <Swiper {...swiperOptions} className="w-full h-full ">
        {carouselData.map((slide) => ({ ...slide, title: slide.title.replace("{appName}", appName) })).map((item, i) => (
          <SwiperSlide
            key={i}
            className="relative w-full h-full overflow-hidden"
          >
            {/* Image */}
            <div className="w-full h-full mb-px ">
              <img
                src={item.thumbnail}
                className="w-full h-full object-cover"
                alt={`carousel-${i}`}
              />
            </div>
            {/* Bottom Gradient Overlay */}
            <div
              className="absolute bottom-0 left-0 right-0 h-[400px] bg-gradient-to-t from-black via-black/80 to-black/4 pointer-events-none z-10"
            ></div>
            {/* Text Content */}
            <div className="absolute bottom-[22%] left-6 text-left z-20 w-[80%] ">
              <h2 className="text-[29px] text-white font-bold mb-1">
                {item.title}
              </h2>
              <p className="text-[16px] text-white">{item.content}</p>
            </div>
          </SwiperSlide>
        ))}
        {/* Swiper pagination is rendered automatically */}
      </Swiper>
    </div>
  );
}

